import { useMemo } from 'react';

import { useAuth } from '../context/auth';

import { createCanAccess } from './can-access';
import {
  canViewOrganizationColumn,
  type OrganizationColumnContext,
} from './organization-column';

import { ROLES } from '@data-access';

export function usePermissions() {
  const { user } = useAuth();
  const role = user?.user_access;

  return useMemo(
    () => ({
      role,
      can: createCanAccess(role),
      isIndustrial: role === ROLES.INDUSTRIAL,
      isAdmin: role === ROLES.ADMIN,
      showOrganizationColumn: (context: OrganizationColumnContext = 'list') =>
        canViewOrganizationColumn(role, context),
    }),
    [role],
  );
}

export type UsePermissionsResult = ReturnType<typeof usePermissions>;
